<template>
  <Widget>
    <WidgetHeader
      class="py-6 border-b"
      :closeable="true"
      @close="$emit('close')"
    >
      <div class="flex items-center">
        <Icon name="tag" class="mr-2" />
        Add Tag
      </div>
    </WidgetHeader>
    <WidgetBody class="pt-5">
      <Superselect
        title="Type"
        class="mb-1"
        v-model="tagType"
        :options="typeOptions"
        label="label"
        track-by="id"
        :multiple="false"
        :allow-empty="false"
      ></Superselect>
      <YInput label="Tag Text" v-model="tagText" class="mb-1" />
      <Superselect
        title="Color"
        v-model="tagColor"
        :options="colorOptions"
        :multiple="false"
        :max-height="80"
        :allow-empty="false"
      >
        <template slot="singleLabel" slot-scope="props">
          <Tag :color="props.option">{{ props.option }}</Tag>
        </template>
        <template slot="option" slot-scope="props">
          <Tag :color="props.option">{{ props.option }}</Tag>
        </template>
      </Superselect>
    </WidgetBody>
    <WidgetFooter class="pt-4 pb-4 flex justify-between bg-gray-100 px-4">
      <y-checkbox
        v-model="closeOnComplete"
        label="Close on Complete"
        class="flex items-center"
      ></y-checkbox>
      <YButton
        :is-loading="isSubmitting"
        color="blue"
        class="ml-auto"
        @click="create"
        @keydown.enter="create"
        >Add</YButton
      >
    </WidgetFooter>
  </Widget>
</template>

<script>
import gql from 'graphql-tag'
import ValidationErrors from '@/assets/js/ValidationErrors'

export default {
  props: {},
  components: {},
  apollo: {
    typeOptions: {
      query: gql`
        query {
          typeOptions: __type(name: "YdnsTagConfigTypeEnum") {
            name
            enumValues {
              name
            }
          }
        }
      `,
      result({ data }) {
        this.typeOptions = data.typeOptions.enumValues.map(enumValue => ({
          id: enumValue.name,
          label: enumValue.name.capitalize()
        }))
      }
    },
    colorOptions: {
      query: gql`
        query {
          colorOptions: __type(name: "YdnsTagConfigColorEnum") {
            name
            enumValues {
              name
            }
          }
        }
      `,
      result({ data }) {
        this.colorOptions = data.colorOptions.enumValues.map(
          enumValue => enumValue.name
        )
      }
    }
  },
  data() {
    return {
      closeOnComplete: true,
      isSubmitting: false,
      tagType: {
        id: 'domain',
        label: 'Domain'
      },
      tagColor: 'blue',
      tagText: null,
      typeOptions: [],
      colorOptions: [],
      validationErrors: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    create() {
      this.isSubmitting = true

      let input = {
        tag: this.tagText,
        color: this.tagColor,
        type: this.tagType.id
      }

      this.$apollo
        .mutate({
          mutation: gql`
            mutation YdnsCreateTag($input: YdnsCreateTagConfigInput!) {
              ydnsCreateTag(input: $input) {
                id
                type
                tag
                color
              }
            }
          `,
          variables: {
            input: input
          }
        })
        .then(() => {
          this.isSubmitting = false
          this.$toastr.s('Tag Created', 'Success!')
          this.$events.emit('refreshYdnsTags')
          if (this.closeOnComplete) {
            this.$emit('close')
          }
        })
        .catch(error => {
          this.isSubmitting = false

          // this.validationErrors = error.extentions.validation ? error.extentions.validation : null;
          let errors = new ValidationErrors()
          errors.extractErrorsFrom(error)
          this.validationErrors = errors.errors

          // if (Object.entries(this.errors).length <= 0) {
          //   toastr.error(error, "Oops!");
          // }
        })
    }
  },
  close() {
    this.$emit('close')
  },
  mounted() {},
  updated() {}
}
</script>
<style></style>
